import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";
import {
  Container,
  Title,
  Text,
  ScreenFourthSection,
  ImageFourthSection,
} from "./FourthSection.styles";
import screenFourthSectionEn from "../../assets/images/screens/fourthSection/screenFourthSectionEn.webp";
import screenFourthSectionRu from "../../assets/images/screens/fourthSection/screenFourthSectionRu.webp";
import screenFourthSectionUk from "../../assets/images/screens/fourthSection/screenFourthSectionUk.webp";
import screenFourthSectionEnBig from "../../assets/images/screens/fourthSection/screenFourthSectionEnBig.webp";
import screenFourthSectionRuBig from "../../assets/images/screens/fourthSection/screenFourthSectionRuBig.webp";
import screenFourthSectionUkBig from "../../assets/images/screens/fourthSection/screenFourthSectionUkBig.webp";
import imageFourthSection from "../../assets/images/imageFourthSection.svg";

const FourthSection = () => {
  const [img, setImg] = useState(screenFourthSectionUk);
  const { t } = useTranslation();
  const width = typeof window !== "undefined" ? window.innerWidth : null;
  const { language } = i18n;

  useEffect(() => {
    const imageSelect = () => {
      switch (language.substring(0, 2)) {
        case "en":
          return setImg(
            width < 768 ? screenFourthSectionEn : screenFourthSectionEnBig
          );
        case "ru":
          return setImg(
            width < 768 ? screenFourthSectionRu : screenFourthSectionRuBig
          );
        default:
          return setImg(
            width < 768 ? screenFourthSectionUk : screenFourthSectionUkBig
          );
      }
    };

    imageSelect();
  }, [language, width]);

  return (
    <Container>
      <Title>{t("thirdArticle")}</Title>
      <Text>{t("thirdText")}</Text>
      <ScreenFourthSection src={img} alt="dashboard mobile screen" />
      <ImageFourthSection src={imageFourthSection} alt="family" />
    </Container>
  );
};

export default FourthSection;
